<template>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <button
            v-for="item in typeCards"
            :key="item.id"
            type="button"
            class="flex flex-col items-center text-center gap-3 px-4 py-4 rounded-lg border-2 bg-theme-card shadow-sm hover:shadow-md hover:bg-theme-hover transition-all cursor-pointer h-full"
            :class="
                itemCurrent === item.id
                    ? 'border-stack-emphasis'
                    : 'border-theme-border'
            "
            @click="selectItem(item.id)"
        >
            <div class="w-full h-16 flex items-end justify-center gap-1.5">
                <template v-if="item.id === 'squareImage'">
                    <div
                        class="w-14 h-14 rounded bg-theme-input border-2 border-theme-primary"
                    ></div>
                </template>
                <template v-else-if="item.id === 'tripleImage'">
                    <div
                        class="w-11 h-7 rounded-sm bg-theme-input border-2 border-theme-primary"
                    ></div>
                    <div
                        class="w-7 h-9 rounded-sm bg-theme-input border-2 border-theme-primary"
                    ></div>
                    <div
                        class="w-5 h-11 rounded-sm bg-theme-input border-2 border-theme-primary"
                    ></div>
                </template>
                <template v-else>
                    <div
                        class="w-16 h-14 rounded bg-theme-input border-2 border-dashed border-theme-primary"
                    ></div>
                </template>
            </div>
            <div class="w-full">
                <p
                    class="font-medium"
                    :class="
                        itemCurrent === item.id
                            ? 'text-stack-emphasis'
                            : 'text-theme-base'
                    "
                >
                    {{ item.name }}
                    <span>{{ item.icon }}</span>
                </p>
                <span
                    class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-theme-input text-theme-muted mt-1"
                >
                    {{
                        item.sizes.length === 1
                            ? "Sube 1 imagen"
                            : `Sube ${item.sizes.length} imágenes`
                    }}
                </span>
                <div>
                    <p class="text-sm text-theme-muted mt-1 text-left">
                        {{ item.description }}
                    </p>
                </div>
                <p class="text-xs text-theme-muted mt-2 text-left">
                    Recomendado:
                    <span
                        v-for="(size, index) in item.sizes"
                        :key="index"
                        class="font-semibold"
                    >
                        {{ size
                        }}{{ index < item.sizes.length - 1 ? " | " : "" }}
                    </span>
                </p>
            </div>
        </button>
    </div>
</template>

<script>
import { sizesImagesAll } from "@/common/fields/sizes-images";

export default {
    name: "ImageTypeSelector",
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => ""
        },
        types: {
            type: Array,
            default: () => sizesImagesAll.map((item) => item.size)
        }
    },
    emits: ["change"],
    computed: {
        typeCards() {
            return sizesImagesAll
                .filter((item) => this.types.includes(item.size))
                .map((item) => ({
                    id: item.size,
                    name: item.title,
                    icon: item.icon,
                    description: item.description,
                    sizes: item.sizes.map(
                        (size) => `${size.width} × ${size.height}`
                    )
                }));
        }
    },
    methods: {
        selectItem(id) {
            this.$emit("change", id);
        }
    }
};
</script>
